import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'

@Pipe({
  name: 'moment'
})
export class MomentPipe implements PipeTransform {

  transform(value: any, format?: any, now?: boolean): any {
    if (!value) {
      return value;
    }

    if (now) {
        return moment(value, format).fromNow();
    }
    return moment(value).format(format);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/moment.pipe.ts